module.exports = __webpack_public_path__ + "static/js/0.edda4c32.chunk.worker.js"